import { connect } from 'react-redux';

import { fetchMerchants } from '../../merchants/actions';
import Content from './Content';

const mapDispatchToProps = {
  fetchMerchants,
};

export default connect(null, mapDispatchToProps)(Content);
